import { Dispatch, SetStateAction } from "react";
import MoveIcon from "./MoveIcon";
import PaletteIcon from "./PaletteIcon";
import useStyleSetting from "./StyleSetting.hook";
import { selectingPartStore } from "@/store/partsStore";

type Props = {
	setShowPalette: Dispatch<SetStateAction<boolean>>;
	setShowPartMove: Dispatch<SetStateAction<boolean>>;
};

/**
 * パーツスタイル設定アイコン コンポーネント
 * @returns {JSX.Element} デザインプレビュー コンポーネント
 */
export default function StyleSettingIcons(props: Props) {
	const { setShowPalette, setShowPartMove } = props;
	const { selectingPart } = selectingPartStore();
	const isDisabledPalette = !selectingPart.partId;

	const isDisabledRange =
		!selectingPart.partId ||
		selectingPart.partName === "hair" ||
		selectingPart.partName === "backHair";
	const { onShowMove, onShowPalette } = useStyleSetting({
		setShowPalette,
		setShowPartMove,
	});

	return (
		<div>
			<MoveIcon
				disabled={isDisabledRange}
				setShowPartMove={setShowPartMove}
				onShowChange={onShowMove}
			/>
			<PaletteIcon
				disabled={isDisabledPalette}
				setShowPalette={setShowPalette}
				onShowChange={onShowPalette}
			/>
		</div>
	);
}
